<script setup lang="ts">
import { computed } from 'vue';
import { AlertCircleIcon, CheckCircleIcon, LoaderIcon, MinusCircleIcon } from '@lucide/vue';
import { SubscriptionRunResult } from '@/types/DashboardSubscription';

const props = defineProps<{
  result: SubscriptionRunResult;
}>();

const badge = computed(() => {
  switch (props.result) {
    case 'DELIVERED':
      return { label: 'Delivered', icon: CheckCircleIcon, tone: 'bg-emerald-50 text-emerald-700' };
    case 'FAILED':
      return { label: 'Failed', icon: AlertCircleIcon, tone: 'bg-red-50 text-red-700' };
    case 'SENDING':
      return { label: 'Sending', icon: LoaderIcon, tone: 'bg-sky-50 text-sky-800' };
    default:
      return { label: 'Skipped', icon: MinusCircleIcon, tone: 'bg-gray-100 text-gray-600' };
  }
});
</script>

<template>
  <span
    class="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs"
    :class="badge.tone">
    <component
      :is="badge.icon"
      :size="12" />
    {{ badge.label }}
  </span>
</template>
